import Vue from 'vue';
import VueI18n from 'vue-i18n'
import VueRouter from 'vue-router';
import ElementUI from 'element-ui';
import Vuetify from 'vuetify'
import 'element-ui/lib/theme-chalk/index.css';
//import { BootstrapVue } from 'bootstrap-vue'; 

//import UploaderPlugin  from '@syncfusion/ej2-vue-inputs';
import locale from 'element-ui/lib/locale/lang/en'
import BlockUIService from './Shared/BlockUIService.js';

import App from './App.vue';
import Layout from './components/Layout/Layout.vue';
import Login from './components/Login/Login.vue';
import Home from './components/Home/Home.vue';
import DataService from './Shared/DataService';
import Helper from './Shared/Helper';


import VueEllipseProgress from 'vue-ellipse-progress';





//Vehicles
import Vehicles from './components/Vehicles/Vehicles.vue';
import Requests from './components/Vehicles/Requests/Requests.vue';
import Invoices from './components/Vehicles/Invoices/Invoices.vue';



//Products
import Products from './components/Products/Products.vue';
import ProductsCounts from './components/Products/ProductsCounts/ProductsCounts.vue';
import InvoiceIn from './components/Products/InvoiceIn/InvoiceIn.vue';
import InvoiceOut from './components/Products/InvoiceOut/InvoiceOut.vue';




//Dictionaries
import Manufacturers from './components/Dictionaries/Manufacturers/Manufacturers.vue';
import Services from './components/Dictionaries/Services/Services.vue';
import VehiclesModels from './components/Dictionaries/VehiclesModels/VehiclesModels.vue';
import Items from './components/Dictionaries/Items/Items.vue';

//Financial
import Financial from './components/Financial/Financial.vue';


//Users
import Users from './components/Users/Users.vue';
import UsersProfile from './components/Users/Profile/Profile.vue';





Vue.use(VueEllipseProgress);

Vue.use(Vuetify)
Vue.use(VueI18n);
Vue.use(VueRouter);
//Vue.use(UploaderPlugin);
Vue.use(ElementUI, { locale });

Vue.config.productionTip = false;

Vue.prototype.$http = DataService;
Vue.prototype.$blockUI = BlockUIService;
Vue.prototype.$helper = Helper;
//Vue.use(BootstrapVue);


export const eventBus = new Vue();


const router = new VueRouter({
    mode: 'history',
    base: __dirname,
    linkActiveClass: 'active',
    routes: [
        {
            path: '/',
            component: Login,
         
        },
         {
            path: '/',
            component: App,
            children: [
                {
                    path: '',
                    component: Layout,
                    children: [
                        { path: '/Home', component: Home },


                        //Products
                        { path: 'Products', component: Products },
                        { path: 'ProductsCounts', component: ProductsCounts },
                        { path: 'InvoiceIn', component: InvoiceIn },
                        { path: 'InvoiceOut', component: InvoiceOut },




                     
                        //Dictionaries
                        { path: 'Manufacturers', component: Manufacturers },
                        { path: 'Services', component: Services },
                        { path: 'VehiclesModels', component: VehiclesModels },
                        { path: 'Items', component: Items },

                        //Vehicles
                        { path: 'Vehicles', component: Vehicles },
                        { path: 'Requests', component: Requests },
                        { path: 'Invoices', component: Invoices },

                        //Financial
                        { path: 'Financial', component: Financial },

                        //Users
                        { path: 'Users', component: Users },
                        { path: 'UsersProfile', component: UsersProfile },
                        

                       
                       
                    ]
                },
            ],
        }
    ]
});



Vue.filter('toUpperCase', function (value) {
    if (!value) return '';
    return value.toUpperCase();
});

new Vue({
    router,
    render: h => {
        return h(App);
    }
}).$mount('#cpanel-management');
